import {Component} from '@angular/core';

@Component({
  selector: 'input-number-ico',
  templateUrl: './input-number-ico.component.html'
})
export class InputNumberIcoComponent {
}
